import React, { useCallback, useEffect, useState } from 'react'
import { Words } from 'pages'
import { audioTranscriptionRQ } from 'store/hooks'
import { useNavigate, useParams } from 'react-router-dom'
import { app } from 'router/routes'
import { correct, incorrect } from 'keys/types'
import { useDispatch } from 'react-redux'
import { actions } from 'store'
import { queryClient as qc } from 'keys'
import { getWordDefsFetch } from 'store/middlewares/words.crud'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { isEmpty } from 'lodash'
import { Button } from 'components/Form'
import { getAssessmentDefFetch } from 'store/middlewares/assessment.crud'
import { AudioTranscriptionStyles } from './Style'
import MicRecorder from 'mic-recorder-to-mp3';

const Mp3Recorder = new MicRecorder({ bitRate: 128 });

const AudioTranscription = () => {
    const params = useParams()
    const queryClient = useQueryClient()

    const { mutateAsync: whisperRQ, isPending: whisperLoading } = audioTranscriptionRQ.useWhisper()
    const { mutateAsync: compareRQ, isPending: compareLoading } = audioTranscriptionRQ.useCompare()

    const [isRecording, setIsRecording] = useState(false)
    const [audioChunks, setAudioChunks] = useState([])

    const assessmentId = params.assessmentID

    const assessmentDef = useQuery({
        queryKey: [qc.assessmentDef],
        queryFn: async ({ signal }) => {
            const { data } = await getAssessmentDefFetch({ id: assessmentId, signal, })
            return data
        }
    })

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const wordDefs = useQuery({
        queryFn: [qc.wordDefs],
        queryFn: async ({ signal }) => {
            const { data } = await getWordDefsFetch({ signal, id: assessmentDef.data.id })
            return data.word_defs
        },
        refetchOnWindowFocus: false,
        enabled: !!assessmentDef?.data?.id
    })

    const transcribeAndCompareLoading = whisperLoading || compareLoading

    const upload = async (blobURL) => {
        const { data: whisperData } = await whisperRQ(blobURL)

        const requestData = {
            spoken: whisperData.text,
            original: assessmentDef?.title + " " + assessmentDef.text
        }

        const { data: compareData } = await compareRQ(requestData)

        const nWords = []
        compareData.map((word) => {
            const { identical, reference, spoken } = word
            nWords.push({
                status: identical ? correct : incorrect,
                word_def_text: reference,
                transcription: spoken,
                word_def: "AUDIO_TRANSCRIPTION"
            })
        })

        dispatch(actions.setWords(nWords))
        navigate(app.assessmentView)
    }

    const startRecord = useCallback(() => {
        Mp3Recorder
            .start()
            .then(() => {
                setIsRecording(true)
            })
            .catch((e) => console.error(e));
    }, [])

    const getMicPermission = useCallback(() => {
        navigator.getUserMedia = (navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia);
        navigator.getUserMedia({ audio: true },
            () => {
                startRecord()
            },
            () => {
                alert("מיקרופון לא פעיל")
                return false
            }
        );
    }, [])

    const stopRecord = useCallback(() => {
        Mp3Recorder
            ?.stop()
            ?.getMp3()
            ?.then(([buffer, blob]) => {
                setIsRecording(false)
                let nAudioChunks = [...audioChunks, blob]
                const audioBlob = new Blob(nAudioChunks, { type: 'audio/mp3' });
                upload(audioBlob)
            }).catch((e) => {
                console.log(e)
            });
    }, [audioChunks, Mp3Recorder])

    useEffect(() => {
        return (() => {
            queryClient.removeQueries([qc.assessmentDef])
            queryClient.removeQueries([qc.assessmentDef])
        })
    }, [])

    return (
        <AudioTranscriptionStyles>
            <div className='actions'>
                <div className='start-finish-actions'>
                    <Button loading={isRecording} width={100} action={getMicPermission} label="התחל " color="thirdly" />
                </div>
                <div className='start-finish-actions'>
                    <Button width={100} action={stopRecord} label="סיום " color="secondary" />
                </div>
            </div>
            <div className='content'>
                {isEmpty(wordDefs?.data) ||
                    <Words
                        type={assessmentDef.data?.visible_type}
                        name={assessmentDef?.name}
                        words={wordDefs?.data}
                        student={true}
                        hideDisabledNext={true}
                    />}
            </div>
            {/* <AssessmentRecord
                customActions={{
                    upload: {
                        onClick: (blobURL) => upload(blobURL),
                        icon: {
                            icon: RemoveRedEye,
                            iconColor: "gray"
                        },
                        label: "",
                        disabled: transcribeAndCompareLoading,
                        loading: transcribeAndCompareLoading
                    }
                }}
            /> */}
        </AudioTranscriptionStyles>
    )
}

export default AudioTranscription